import createOneUpChild from 'emun.shopping.admin/admin-order-one-up-child'
import templateUrl from 'emun.shopping.admin/admin-order-one-up-details.htm'

export default createOneUpChild(templateUrl);